import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import { AuthProvider, useAuth } from "./context/AuthContext";
import Layout from "./components/Layout";
import LandingPage from "./pages/LandingPage";
import { LoginPage, RegisterPage, AuthCallback } from "./pages/AuthPages";
import FeedPage from "./pages/FeedPage";
import UploadPage from "./pages/UploadPage";
import PerformanceDetailPage from "./pages/PerformanceDetailPage";
import LeaderboardPage from "./pages/LeaderboardPage";
import ChartsPage from "./pages/ChartsPage";
import ProfilePage from "./pages/ProfilePage";
import PracticeRoomPage from "./pages/PracticeRoomPage";
import AdminPage from "./pages/AdminPage";

// Protected Route Component
const ProtectedRoute = ({ children }) => {
    const { isAuthenticated, loading } = useAuth();
    const location = useLocation();

    if (loading) {
        return (
            <div className="min-h-screen bg-void flex items-center justify-center">
                <div className="w-8 h-8 border-2 border-primary border-t-transparent rounded-full animate-spin" />
            </div>
        );
    }

    if (!isAuthenticated) {
        return <Navigate to="/login" state={{ from: location }} replace />;
    }

    return children;
};

function AppRouter() {
    return (
        <Routes>
            {/* Public Routes — landing + sign-in only (decision A: login to enter) */}
            <Route path="/" element={<LandingPage />} />
            <Route path="/login" element={<LoginPage />} />
            <Route path="/register" element={<RegisterPage />} />
            <Route path="/auth/callback" element={<AuthCallback />} />

            {/* Everything else requires a signed-in user */}
            <Route path="/feed" element={<ProtectedRoute><Layout><FeedPage /></Layout></ProtectedRoute>} />
            <Route path="/leaderboard" element={<ProtectedRoute><Layout><LeaderboardPage /></Layout></ProtectedRoute>} />
            <Route path="/charts" element={<ProtectedRoute><Layout><ChartsPage /></Layout></ProtectedRoute>} />
            <Route path="/performance/:performanceId" element={<ProtectedRoute><Layout><PerformanceDetailPage /></Layout></ProtectedRoute>} />
            <Route path="/profile/:userId" element={<ProtectedRoute><Layout><ProfilePage /></Layout></ProtectedRoute>} />
            <Route
                path="/upload"
                element={
                    <ProtectedRoute>
                        <Layout><UploadPage /></Layout>
                    </ProtectedRoute>
                }
            />
            <Route
                path="/practice"
                element={
                    <ProtectedRoute>
                        <Layout><PracticeRoomPage /></Layout>
                    </ProtectedRoute>
                }
            />
            <Route
                path="/admin"
                element={
                    <ProtectedRoute>
                        <AdminPage />
                    </ProtectedRoute>
                }
            />

            {/* Catch all */}
            <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
    );
}

function App() {
    return (
        <div className="App">
            <BrowserRouter>
                <AuthProvider>
                    <AppRouter />
                    <Toaster 
                        position="top-right" 
                        richColors 
                        closeButton
                        toastOptions={{
                            className: 'bg-paper border-white/10 text-white',
                        }}
                    />
                </AuthProvider>
            </BrowserRouter>
        </div>
    );
}

export default App;
